"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _rsManagement = require("@/api/rsManagement");
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'OrderDetail',
  data: function data() {
    return {
      visible: false,
      loading: false,
      orderDetail: {},
      isExpanded: false
    };
  },
  methods: {
    // 打开弹窗
    open: function open(orderNo) {
      if (!orderNo) {
        this.$message.error('订单ID不能为空');
        return;
      }
      this.visible = true;
      this.getOrderDetail(orderNo);
    },
    // 获取订单详情
    getOrderDetail: function () {
      var _getOrderDetail2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(orderNo) {
        var response, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              this.loading = true;
              _context.p = 1;
              _context.n = 2;
              return (0, _rsManagement.getOrderDetail)(orderNo);
            case 2:
              response = _context.v;
              console.log(response);
              if (response) {
                this.orderDetail = response;
              } else {
                this.orderDetail = {};
                this.$message.warning('未获取到订单详情');
              }
              _context.n = 4;
              break;
            case 3:
              _context.p = 3;
              _t = _context.v;
              console.error('获取订单详情失败：', _t);
              this.$message.error('获取订单详情失败：' + (_t.message || '未知错误'));
              this.orderDetail = {};
            case 4:
              _context.p = 4;
              this.loading = false;
              return _context.f(4);
            case 5:
              return _context.a(2);
          }
        }, _callee, this, [[1, 3, 4, 5]]);
      }));
      function getOrderDetail(_x) {
        return _getOrderDetail2.apply(this, arguments);
      }
      return getOrderDetail;
    }(),
    // 关闭弹窗
    handleClose: function handleClose() {
      this.visible = false;
      this.orderDetail = {};
      this.isExpanded = false;
    },
    // 切换展开状态
    toggleExpand: function toggleExpand() {
      this.isExpanded = !this.isExpanded;
    },
    // 获取订单状态类型
    getOrderStatusType: function getOrderStatusType(status) {
      var statusMap = {
        '已取消': 'danger',
        // 已取消 - 红色表示取消状态
        '待支付': 'warning',
        // 待支付 - 橙色表示等待状态
        '待接单': 'primary',
        // 待接单 - 蓝色表示等待接单状态
        '备货中': 'primary',
        // 备货中 - 蓝色表示处理中状态
        '待自提': 'info',
        // 待自提 - 灰色表示等待自提状态
        '配送中': 'primary',
        // 配送中 - 蓝色表示配送中状态
        '已退款': 'warning',
        // 已退款 - 橙色表示退款状态
        '已完结': 'success',
        // 已完结 - 绿色表示完成状态
        '已支付': 'primary',
        // 已支付 - 蓝色表示进行中状态
        '处理中': 'info',
        // 处理中 - 灰色表示处理状态
        '已发货': 'primary',
        // 已发货 - 蓝色表示进行中状态
        '已签收': 'success',
        // 已签收 - 绿色表示完成状态
        '退款中': 'warning',
        // 退款中 - 橙色表示处理中状态
        '退款成功': 'success',
        // 退款成功 - 绿色表示完成状态
        '退款失败': 'danger',
        // 退款失败 - 红色表示失败状态
        '拒绝退款': 'danger',
        // 拒绝退款 - 红色表示拒绝状态
        '已关闭': 'info',
        // 已关闭 - 灰色表示关闭状态
        '支付失败': 'danger',
        // 支付失败 - 红色表示失败状态
        '向第三方下单失败': 'danger',
        // 向第三方下单失败 - 红色表示失败状态
        '部分退款': 'warning',
        // 部分退款 - 橙色表示部分处理状态
        '售后中': 'info',
        // 售后中 - 灰色表示处理状态
        '部分发货': 'primary' // 部分发货 - 蓝色表示部分完成状态
      };
      return statusMap[status] || 'info';
    }
  }
};